import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    API:process.env.NODE_ENV === 'production'?"http://pdms.usc.edu/dsci-554-projects/project-pajamas/":"http://localhost:8080/", // change if deployed
    Countries:['Japan','Italy','Finland','France','Spain','United Kingdom','Canada',
    'United States','Australia','Iceland','China','Chile','Turkey','Mexico'],
    Color:["#67000d","#67000d","#67000d","#67000d","#67000d","#a50f15","#a50f15",
    "#cb181d","#cb181d","#cb181d","#fb6a4a","#fb6a4a","#fc9272","#fcbba1"],
    
    birthRateData:null,
    birthBearData:null,
    populationAgeAboveData:null,
    lifeExpectancyData:null,

    GdpGData:null,
    ExpImpData:null,
    countries10mData:null,
    agingPopulationData:null,
    worldHistoryData:null,
    ExRateData:null,
    HPAData:null,

    migrateBarData:null,
    unemploymentLineChartData:null,
  },
  mutations: {
    birthRateData(state, payload) {
      state.birthRateData = payload;
    },
    birthBearData(state, payload) {
      state.birthBearData = payload;
    },
    populationAgeAboveData(state, payload) {
      state.populationAgeAboveData = payload;
    },
    lifeExpectancyData(state, payload) {
      state.lifeExpectancyData = payload;
    },
    GdpGData(state, payload){
      state.GdpGData = payload;
    },
    countries10mData(state, payload) {
      state.countries10mData = payload;
    },
    agingPopulationData(state, payload) {
      state.agingPopulationData = payload;
    },
    worldHistoryData(state, payload) {
      state.worldHistoryData = payload;
    },
    ExpImpData(state, payload){
      state.ExpImpData = payload;
    },
    ExRateData(state, payload){
      state.ExRateData = payload;
    },
    HPAData(state, payload){
      state.HPAData = payload;
    },
    migrateBarData(state, payload){
      state.migrateBarData = payload;
    },
    unemploymentLineChartData(state, payload){
      state.unemploymentLineChartData = payload;
    },
  },
  actions: {
  },
  modules: {
  }
})
